import { bootstrapAuth } from 'modules/auth/authSlice';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { RootState } from 'store';
import { FullPageLoader } from 'components/Loader/Loader';

const AuthBootstrapper: FC = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const ready = useSelector((state: RootState) => state.auth.ready);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  useEffect(() => {
    const redirectUrl = window.location.origin.replace(/\/?$/, '/');
    dispatch(bootstrapAuth(redirectUrl, query));
  }, []);

  if (!ready) {
    return <FullPageLoader />;
  }

  return <>{children}</>;
};

export default AuthBootstrapper;
